import React from "react"
import { Helmet } from "react-helmet"
import useSiteMetadata from "../../hooks/use-site-metadata"
import { useLocation } from "@reach/router"

const SEO = ({ title, description, image, article }) => {
  const { pathname } = useLocation()

  const {
    title: defaultTitle,
    titleTemplate,
    description: defaultDescription,
    siteUrl,
    image: defaultImage,
    twitterUsername,
  } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  }

  return (
    <Helmet title={seo.title} titleTemplate={titleTemplate}>
      {/* HTML */}
      <html lang="tr" />

      {/* Meta */}
      <meta charSet="utf-8" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover"
      />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      {/* OpenGraph */}
      {seo.url && <meta property="og:url" content={seo.url} />}
      {article && <meta property="og:type" content="article" />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {seo.image && <meta property="og:image" content={seo.image} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {seo.image && <meta name="twitter:image" content={seo.image} />}

      {/* ================= GOOGLE ADS ================= */}

      {/* Google Ads Global Site Tag */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=AW-17804829262"
      />
      <script>{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-17804829262');
      `}</script>

      {/* Google Ads Conversion Event Function */}
      <script>{`
        function gtag_report_conversion(url) {
          var callback = function () {
            if (typeof(url) !== 'undefined') {
              window.location = url;
            }
          };
          gtag('event', 'conversion', {
            'send_to': 'AW-17804829262/zEB4CJv6ttUbEM7EgKpC',
            'event_callback': callback
          });
          return false;
        }
      `}</script>

      {/* ================= END GOOGLE ADS ================= */}
    </Helmet>
  )
}

export default SEO
